import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { jsonp } from '@ifeng-fe/ui_base';
import { isGrounds } from '@src/public/utils/app';
import { isWeChat } from '@src/public/utils';
import { getQuery } from '@src/public/utils/url';

export const useWeixinLogin = () => {
    useEffect(() => {
        if (!isGrounds && isWeChat()) {
            const token = Cookies.get('tl_sid');
            const code = getQuery(window.location.href, 'code');

            if (!token && code) {
                jsonp(`https://user.iclient.ifeng.com/Api_User_Userbasic/weixinLogin?code=${code}&proid=weixinh5`, {
                    data: { code },
                    jsonpCallback: 'getUserData',
                    cache: false,
                }).then(res => {
                    if (res && res.code === 200 && res.data) {
                        const { token } = res.data;

                        Cookies.set('tl_sid', token, { expires: 30, domain: '.ifeng.com', path: '/' });
                    }
                });
            }
        }
    }, []);
};
